<template>
    <div class="index_content">
        <div class="mine_title">
            Personal Settings
        </div>
        <div class="mine_main" :class="{ 'sidebar-hidden': !showSidebar }">
            <div class="main-side" v-show="showSidebar">
                <p v-for="(value, index) in tabList" :key="index" :class="currentIndex == index ? 'acTitle' : ''" @click="clickTab(index)">{{ value }}</p>
            </div>
            <div class="main-content" :class="{ 'full-width': !showSidebar }">
                <Information v-if="0 == currentIndex"/>
                <Certificate v-if="1 == currentIndex"/>
                <Personal v-if="2 == currentIndex"/>
                <Inviter v-if="3 == currentIndex"/>
                <Myinviter v-if="4 == currentIndex"/>
            </div>
        </div>
    </div>
  </template>
<script>
import Information from './childrens/Information.vue'
import Certificate from './childrens/Certificate.vue'
import Personal from './childrens/Personal.vue'
import Inviter from './childrens/Inviter.vue'
import Myinviter from './childrens/Myinviter.vue'
export default {
  data () {
    return {
      // 菜单列表
      tabList: [
        'Account Information',
        'Teacher certificate',
        "Teacher's personal information",
        'My Referrals',
        'My Referrer'
      ],
      // 当前激活菜单
      currentIndex: 0,
      // 是否显示侧边栏
      showSidebar: true

    }
  },
  components: {
    Information,
    Certificate,
    Personal,
    Inviter,
    Myinviter
  },
  created () {
    this.getUrl()
  },
  methods: {
    clickTab (index) {
      this.currentIndex = index
    },
    toggleSidebar () {
      this.showSidebar = !this.showSidebar
    },
    async getUrl () {
      await this.$http.get('/tutor/api/uploadDomail').then(res => {
        sessionStorage.setItem('uploadUrl', res.data.data.upload_domin)
      })
    }
  }
}
</script>
  <style lang="less" scoped>
  .index_content{
    background: #fff;
    margin-top: 20px;
    padding: 30px;
    .mine_title{
        font-family: Roboto;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        letter-spacing: 0px;
        margin-bottom: 20px;
        font-feature-settings: "kern" on;
        display: flex;
        align-items: center;
    }
    .mine_main{
        display: flex;
        flex-direction: row;
        .main-side{
            border-right: 1px solid #eee;
            min-height: 568px;
            width:300px;
            p{
                line-height: 3;
                font-family: Roboto;
                font-size: 16px;
                font-weight: normal;
                cursor: pointer;
            }
        }
        .main-content{
            width: calc(100% - 300px);
            transition: width 0.3s ease;

            &.full-width {
                width: 100%;
            }
        }

        &.sidebar-hidden {
            .main-content {
                width: 100%;
            }
        }
    }
  }
  .acTitle{
    color: #FF904D;
  }
  </style>



// WEBPACK FOOTER //
// src/components/views/Mine.vue